// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
img,
button,
input,
form,
textarea,
label,
header,
footer,
div,
p,
a,
span {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background-color: transparent;
  font-family: var(--primary-font-family);
}

body {
  /* attempt to beautify font rendering */
  text-rendering: optimizeLegibility;
  font-feature-settings: "kern";
  -webkit-font-feature-settings: "kern";
  -moz-font-feature-settings: "kern";
  -moz-font-feature-settings: "kern=1";
  overflow-wrap: break-word;
}

a {
  color: var(--brand-primary-40);
}

mark {
  background-color: transparent;
}

.input-panel-mention {
  font-weight: 500;
  color: var(--brand-primary-40);
  text-decoration: inherit;
  user-select: all;
}

::selection {
  background-color: var(--brand-primary-40_20);
}

html,
body,
#gem {
  min-height: var(--app-height);
  min-width: 360px;
  font-size: 15px;
  font-family: var(--primary-font-family);
}

.system-message-title {
  color: inherit;
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
}

.rlottie {
  /* Указываем браузеру что это animating content */
  will-change: contents;
  /* Размещаем в отдельном слое отрисовки */
  isolation: isolate;
  /* Содержит paint операции в этом элементе */
  contain: paint;
  display: block;
  margin: 0;
  padding: 0;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;;;;;;EAoBE,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;EACA,6BAAA;EACA,uCAAA;AAEF;;AACA;EACE,uCAAA;EACA,kCAAA;EACA,6BAAA;EACA,qCAAA;EACA,kCAAA;EACA,oCAAA;EACA,yBAAA;AAEF;;AACA;EACE,8BAAA;AAEF;;AACA;EACE,6BAAA;AAEF;;AACA;EACE,gBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;AAEF;;AACA;EACE,4CAAA;AAEF;;AACA;;;EAGE,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAEF;;AACA;EACE,cAAA;EACA,4BAAA;EACA,8CAAA;AAEF;;AACA;EACE,iDAAA;EACA,qBAAA;EACA,yCAAA;EACA,kBAAA;EACA,4CAAA;EACA,cAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;AAEF","sourcesContent":["html,\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nimg,\nbutton,\ninput,\nform,\ntextarea,\nlabel,\nheader,\nfooter,\ndiv,\np,\na,\nspan {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  font-size: 100%;\n  vertical-align: baseline;\n  background-color: transparent;\n  font-family: var(--primary-font-family);\n}\n\nbody {\n  /* attempt to beautify font rendering */\n  text-rendering: optimizeLegibility;\n  font-feature-settings: 'kern';\n  -webkit-font-feature-settings: 'kern';\n  -moz-font-feature-settings: 'kern';\n  -moz-font-feature-settings: 'kern=1';\n  overflow-wrap: break-word;\n}\n\na {\n  color: var(--brand-primary-40);\n}\n\nmark {\n  background-color: transparent;\n}\n\n.input-panel-mention {\n  font-weight: 500;\n  color: var(--brand-primary-40);\n  text-decoration: inherit;\n  user-select: all;\n}\n\n::selection {\n  background-color: var(--brand-primary-40_20);\n}\n\nhtml,\nbody,\n#gem {\n  min-height: var(--app-height);\n  min-width: 360px;\n  font-size: 15px;\n  font-family: var(--primary-font-family);\n}\n\n.system-message-title {\n  color: inherit;\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n}\n\n.rlottie {\n  /* Указываем браузеру что это animating content */\n  will-change: contents;\n  /* Размещаем в отдельном слое отрисовки */\n  isolation: isolate;\n  /* Содержит paint операции в этом элементе */\n  contain: paint;\n  display: block;\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
